<template>
  <IziGrid class="topics-container">
    <IziCol>
      <SelectButton
        v-model="topics"
        :options="paymentOptions"
        optionLabel="name"
        multiple
      >
      </SelectButton>
    </IziCol>
  </IziGrid>
</template>

<script lang="ts">
import { watchEffect, ref } from "vue";
import { Options } from "vue-class-component";
import Base from "../../base/Base.vue";
@Options({
  props: ["data"]
})
export default class Topics extends Base {
  topics = ref([]);
  public data = {
    topics: this.topics
  } as any;
  paymentOptions = [
    { name: "Science", value: "science" },
    { name: "Art", value: "art" }
  ];

  created() {
    watchEffect(() => {
      const data = {
        topics: this.topics
      };
      this.$emit("update:data", data);
    });
  }
}
</script>
<style lang="scss">
.topics-container {
  .p-selectbutton {
    .p-button.p-component {
      margin-left: 10px;
      border-radius: 24px;
      border-right: 1px solid rgba(0, 0, 0, 0.12);
    }
  }
}
</style>
